import { createStore } from 'vuex'

export default createStore({
    state: () => ({
        isAddRoutes: false,
        openTab: [],
        activeTabPath: '',
        pageSize: '10',
        pageSizes: [10, 15, 30, 50, 100]
    }),
    mutations: {
        // 添加tab事件
        add_tabs (state, data) {
            state.openTab.push(data)
        },
        // 替换tab
        replace_tabs (state, data) {
            let index = 0
            let itemExist = null
            let itemTemp = null
            let findFlag = 0
            for (itemExist of state.openTab) {
                for (itemTemp of data.replace) {
                    if (itemExist.path === itemTemp) {
                        findFlag = 1
                        break
                    }
                }
                if (findFlag === 1) {
                    break
                }
                index++
            }
            state.openTab.splice(index, 1, data)
        },
        // 删除
        delete_tabs (state, path) {
            let index = 0
            let item = null
            for (item of state.openTab) {
                if (item.path === path) {
                    break
                }
                index++
            }
            state.openTab.splice(index, 1)
        },
        clean_tabs: (state) => {
            state.openTab = []
        },
        // 设置高亮tab
        set_active_path (state, path) {
            state.activeTabPath = path
        },
        setPageSize: (state, pageSize) => {
            state.pageSize = pageSize
            localStorage.setItem('page_size', pageSize)
        },
        setIsAddRoutes: (state, isAddRoutes) => {
            state.isAddRoutes = isAddRoutes
        }
    },
    getters: {
        isAddRoutes: state => state.isAddRoutes,
        pageSize: state => state.pageSize,
        pageSizes: state => state.pageSizes
    },
    actions: {},
    modules: {}
})
